import * as React from 'react';

import moment from 'moment-timezone';
import PropTypes from 'prop-types';

import Icon from 'bundles/internal-ui/components/icon/Icon';

class TableCell extends React.Component {
  static propTypes = {
    field: PropTypes.any.isRequired,
    column: PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
      type: PropTypes.string,
      format: PropTypes.string,
      tooltip: PropTypes.string,
      width: PropTypes.number,
      render: PropTypes.func,
    }).isRequired,
    tooltip: PropTypes.string,
    row: PropTypes.any.isRequired,
  };

  renderContents() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
    const style = { width: this.props.column.width };
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
    if (this.props.column.render) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
      return this.props.column.render(this.props.field, this.props.row);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
    } else if (this.props.column.type === 'code') {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'field' does not exist on type 'Readonly<... Remove this comment to see the full error message
      return <code style={style}>{this.props.field}</code>;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
    } else if (this.props.column.type === 'pre') {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'field' does not exist on type 'Readonly<... Remove this comment to see the full error message
      return <pre style={style}>{this.props.field}</pre>;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
    } else if (this.props.column.type === 'boolIcon') {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'field' does not exist on type 'Readonly<... Remove this comment to see the full error message
      if (this.props.field) {
        return (
          <span className="boolicon true">
            <Icon name="check_circle" />
          </span>
        );
      } else {
        return (
          <span className="boolicon false">
            <Icon name="cancel" />
          </span>
        );
      }
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
    } else if (this.props.column.type === 'timestamp') {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'field' does not exist on type 'Readonly<... Remove this comment to see the full error message
      if (this.props.field) {
        const time = moment
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'field' does not exist on type 'Readonly<... Remove this comment to see the full error message
          .tz(this.props.field, 'America/Los_Angeles')
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
          .format(this.props.column.format || 'MMMM Do YYYY, h:mm:ss a z');
        return <span style={style}>{time}</span>;
      } else {
        return <span>N/A</span>;
      }
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'field' does not exist on type 'Readonly<... Remove this comment to see the full error message
      return <span style={style}>{this.props.field}</span>;
    }
  }

  render() {
    return (
      <td>
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'tooltip' does not exist on type 'Readonl... Remove this comment to see the full error message */}
        <div title={this.props.tooltip}>{this.renderContents()}</div>
      </td>
    );
  }
}

export default TableCell;
